import script from "./SingleOption.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleOption.vue?vue&type=script&setup=true&lang=js"

import "./SingleOption.vue?vue&type=style&index=0&id=162fddd2&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-162fddd2"]])

export default __exports__